import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
// Toast Context
const ToastContext = React.createContext(null);
export const useToast = () => {
    return React.useContext(ToastContext);
};
// Toast Provider
export function ToastProvider({ children }) {
    const [toasts, setToasts] = React.useState([]);
    const addToast = (toast) => {
        setToasts([...toasts, toast]);
    };
    const removeToast = (id) => {
        setToasts(toasts.filter(toast => toast.id !== id));
    };
    return (_jsxs(ToastContext.Provider, { value: { addToast, removeToast }, children: [children, _jsx("div", { className: "w-full px-4 sm:px-6 md:px-8 mx-auto fixed bottom-2 sm:m-2 sm:m-2 sm:m-0 right-0 p-2 sm:p-2 sm:p-2 sm:p-4", children: toasts.map(toast => (_jsxs("div", { className: "mb-2 p-2 sm:p-2 sm:p-2 sm:p-2 bg-gray-800 text-white rounded", children: [_jsx("strong", { children: toast.title }), _jsx("p", { children: toast.description })] }, toast.id))) })] }));
}
;
const alertVariants = cva("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
    variants: {
        variant: {
            default: "bg-background text-foreground",
            destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",
            success: "border-green-500/50 text-green-600 dark:border-green-500 [&>svg]:text-green-600",
            warning: "border-yellow-500/50 text-yellow-600 dark:border-yellow-500 [&>svg]:text-yellow-600",
            info: "border-blue-500/50 text-blue-600 dark:border-blue-500 [&>svg]:text-blue-600",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (_jsx("div", { ref: ref, role: "alert", className: cn(alertVariants({ variant }), className), ...props })));
Alert.displayName = "Alert";
const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (_jsx("h5", { ref: ref, className: cn("mb-1 font-medium leading-none tracking-tight", className), ...props })));
AlertTitle.displayName = "AlertTitle";
const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn("text-sm [&_p]:leading-relaxed", className), ...props })));
AlertDescription.displayName = "AlertDescription";
export { Alert, AlertTitle, AlertDescription };
